// extracted by mini-css-extract-plugin
module.exports = {"textarea":"OtherResources_textarea__UKN3m","description":"OtherResources_description__2NcDa"};